import React, { useEffect, useState } from "react";
import DynamicComponentRenderer from "../../components/DynamicComponentRenderer";
import Heading from "../../components/Heading";
import CommonGrid from "../../components/CommonGrid";
import { gridColumnsLenderOnboarding } from "../../Utils/TableColumnDefs";
import axios from "../../axios";
import urls from "../../Utils/urls";
import { useNavigate } from "react-router-dom";
import { useAbortController } from "../../hooks/useAbortController";
import { oracleConfig } from "../../Utils/constant";

const LenderOnboarding = () => {
  const [LenderData, setLenderData] = useState([]);
  const [loading, setLoading] = useState("loading");
  const navigate = useNavigate();
  const { signal } = useAbortController();

  useEffect(() => {
    // setLenderData([]);
    const fetchData = async () => {
      const res = await axios.get(
        urls.dashboard.getLenderOnboard(
          `${localStorage.getItem("email_for_forgot_password")}`
        ),
        oracleConfig,
        { signal }
      );
      let data = res.data.items;
      if (data.length) {
        const output = data.map((item) => {
          const parsedData = JSON.parse(item.json_data);
          return {
            jsonId: item?.json_id || "",
            name: parsedData?.general?.name || "",
            firstName: parsedData?.general?.firstName || "",
            email: parsedData?.general?.email || "",
            status: item?.process_flg === "N" ? "Pending" : "Approved",
          };
        });
        setLenderData(output);
      }
      setLoading("fulfilled");
    };
    fetchData();
  }, []);
  const componentConfig = [
    {
      component: <Heading className="col-sm-12" text="Lender Onboarding" />,
      role: ["Both"],
      className: "col-sm-6 px-4",
    },
    {
      component: <Button onClick={() => navigate("/lender-onboard/Create")} />,
      role: ["Both"],
      className: "col-sm-6 px-4 text-end",
    },
    {
      component: (
        <CommonGrid
          className={"bg-white col-sm-12 mt-5"}
          title={"Available Lender Leads"}
          gridColumns={gridColumnsLenderOnboarding}
          columnData={LenderData}
          status={loading}
        />
      ),
      role: ["Both"],
      className: "col-sm-12 px-4",
    },
  ];
  return (
    <div
      className="text-start container-fluid my-0 px-0"
      style={{ overflowY: "scroll" }}
    >
      <section
        className=" rounded py-5"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <article className="container-fluid row">
          <DynamicComponentRenderer componentConfig={componentConfig} />
        </article>
      </section>
    </div>
  );
};

export default LenderOnboarding;

const Button = ({ onClick }) => {
  return (
    <button className="btn btn-primary text-end text-white" onClick={onClick}>
      Add Lender
    </button>
  );
};
